// Marca de UCORP: el tile acero con la U mas la palabra en SemiBold, la misma
// de la torre, la demo y la landing (gestion/07_identidad/components/marca).
// Es tipografica a proposito: no hay isotipo. Nada de SVG de logo.
import { cn } from "./cn.js";

const TAMANOS = {
  sm: { tile: "size-7 rounded-md text-[15px]", word: "text-[15px]", gap: "gap-2.5" },
  md: { tile: "size-8 rounded-md text-base", word: "text-lg", gap: "gap-2.5" },
  lg: { tile: "size-11 rounded-lg text-xl", word: "text-2xl", gap: "gap-3" },
} as const;

export function Brand({
  size = "md",
  className,
  wordClassName,
}: {
  size?: keyof typeof TAMANOS;
  className?: string;
  /** Para ocultar la palabra (barra compacta) sin perderla del nombre accesible. */
  wordClassName?: string;
}): React.JSX.Element {
  const t = TAMANOS[size];
  return (
    <span className={cn("inline-flex items-center font-semibold tracking-display text-blanco", t.gap, className)}>
      <span aria-hidden="true" className={cn("grid shrink-0 place-items-center bg-acero font-semibold text-blanco", t.tile)}>
        U
      </span>
      <span className={cn(t.word, wordClassName)}>UCORP</span>
    </span>
  );
}
